import { SingleDonation as SingleDonationForm } from "@bgea-js/form-templates";
import customConfirmationBibleDonation from "../../../../src/content/daily-bible-reading/customConfirmation";
import "../../../../src/content/daily-bible-reading/dailybible.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationBibleDonation,
  React
};